import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Button,
  Form,
  Card,
  Image
} from "react-bootstrap";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaWhatsapp
} from "react-icons/fa";
import contactBanner from "../Images/contact banner1.png";
import "./Contact.css";

function Contact() {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}
Message: ${formData.message}
    `;

    const whatsappUrl = `https://wa.me/917007738677?text=${encodeURIComponent(text)}`;

    window.open(whatsappUrl, "_blank");
  };
  return (
    <div>
      <Image src={contactBanner} alt="Nutrinest Contact" className="contact-banner" />
      <div className="contact-page py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>

              <Card className="contact-card border-0 shadow-lg rounded-4 p-4 p-md-5">

                <Row className="align-items-center g-5">

                  {/* Left Side */}
                  <Col lg={5}>
                    <div className="contact-content">

                      <h1 className="contact-title">
                        Let's Connect
                      </h1>

                      <p className="contact-description">
                        Tell us about your health goals, and we’ll help
                        you with personalized nutrition guidance.
                      </p>

                      <div className="contact-info">

                        <div className="info-item">

                          <a href="mailto:dakshanutrinest@gmail.com" className="contact-link">
                            <FaEnvelope className="info-icon" />
                            <span className="ms-2">dakshanutrinest@gmail.com</span>
                          </a>

                        </div>

                        <div className="info-item">

                          <a href="tel:+917007738677" className="contact-link">
                            <FaPhoneAlt className="info-icon" />
                            <span className="ms-2">+91 70077 38677</span>
                          </a>

                        </div>

                        <div className="info-item">
                          <a href="https://wa.me/917007738677" className="contact-link" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp className="info-icon" />
                            <span className="ms-2">+91 70077 38677</span>
                          </a>
                        </div>

                      </div>

                    </div>
                  </Col>

                  {/* Right Side Form */}
                  <Col lg={7}>
                    <Form onSubmit={handleSubmit}>

                      <Row className="g-3">

                        <Col md={6}>
                          <Form.Control
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            placeholder="First name*"
                            required
                          />
                        </Col>

                        <Col md={6}>
                          <Form.Control
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            placeholder="Last name*"
                            required
                          />
                        </Col>

                        <Col md={6}>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email address*"
                            required
                          />
                        </Col>

                        <Col md={6}>
                          <Form.Control
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Phone number*"
                            required
                          />
                        </Col>

                        <Col xs={12}>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Message*"
                            required
                          />
                        </Col>

                        <Col xs={12}>
                          <Button type="submit" variant="outline-success" className="contact-button">
                            Send Message
                          </Button>
                        </Col>

                      </Row>

                    </Form>
                  </Col>

                </Row>

              </Card>

            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Contact;